import React from "react";
export var CaretDown = function (_a) {
    var className = _a.className, fill = _a.fill, title = _a.title, width = _a.width, height = _a.height;
    return (React.createElement("svg", { className: className, width: width, height: height, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, title),
        React.createElement("path", { d: "M9.445 0c.142 0 .284.059.392.176a.635.635 0 010 .848l-4.444 4.8a.527.527 0 01-.786 0l-4.444-4.8a.627.627 0 01-.16-.477A.5.5 0 01.5 0h8.943z", fill: fill })));
};
